/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_StandingsInputs */

const en_us2_clubs_standings = /** @type {(inputs: Clubs_StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ranking`)
};

const pt_br2_clubs_standings = /** @type {(inputs: Clubs_StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ranking`)
};

const es_419_clubs_standings = /** @type {(inputs: Clubs_StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ranking`)
};

const pt_pt2_clubs_standings = /** @type {(inputs: Clubs_StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificação`)
};

const fr_fr2_clubs_standings = /** @type {(inputs: Clubs_StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classement`)
};

const de_de2_clubs_standings = /** @type {(inputs: Clubs_StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rangliste`)
};

const it_it2_clubs_standings = /** @type {(inputs: Clubs_StandingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classifica`)
};

/**
* | output |
* | --- |
* | "Ranking" |
*
* @param {Clubs_StandingsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_standings = /** @type {((inputs?: Clubs_StandingsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_StandingsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_standings(inputs)
	if (locale === "es-419") return es_419_clubs_standings(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_standings(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_standings(inputs)
	if (locale === "de-DE") return de_de2_clubs_standings(inputs)
	if (locale === "it-IT") return it_it2_clubs_standings(inputs)
	return en_us2_clubs_standings(inputs)
});
export { clubs_standings as "clubs.standings" }